const SOC = {
  x: 'https://x.com/gamsterio',
  telegram: 'https://t.me/gamsterio',
  discord: 'https://discord.gg/EK7S2QHq8t',
} as const;

export default SOC;
